// extracted by mini-css-extract-plugin
export default {"Environment":"Environment_Environment__T2Na0","ArrowDropDownIcon":"Environment_ArrowDropDownIcon__e6WAN"};